// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3kHlx","action":"Button_action__2pgAd","primary":"Button_primary__76Z74"};